import cx from 'classnames'
import { forwardRef } from 'react'

const profileColors = [
  'bg-red-500',
  'bg-orange-500',
  'bg-amber-500',
  'bg-yellow-500',
  'bg-lime-500',
  'bg-green-500',
  'bg-emerald-500',
  'bg-teal-500',
  'bg-cyan-500',
  'bg-sky-500',
  'bg-indigo-500',
  'bg-violet-500',
  'bg-purple-500',
  'bg-fuchsia-500',
  'bg-pink-500',
  'bg-rose-500',
] as const

type Props = {
  name?: string
  className?: string
  hashingString?: string
}

export const ProfileImage = forwardRef<HTMLDivElement, Props>(({ name, className, hashingString, ...props }, ref) => {
  const firstLetter = name?.[0]?.toUpperCase() ?? '?'
  const profileColor =
    profileColors[(hashingString ? hashingString?.charCodeAt(0) : firstLetter.charCodeAt(0))! % profileColors.length]
  return (
    <div
      ref={ref}
      {...props}
      className={cx('flex flex-none items-center justify-center rounded-full text-white', profileColor, className)}
    >
      {firstLetter}
    </div>
  )
})
